import React from 'react';
import { Card } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { MonthlyFinanceDataDTO } from 'app/shared/model/finance.model';

interface PaymentEncaissementChartProps {
  monthlyFinanceDataByEcoleId: MonthlyFinanceDataDTO[];
}

const BarChartCard: React.FC<PaymentEncaissementChartProps> = ({ monthlyFinanceDataByEcoleId }) => {
  return (
    <Card title="Encaissement et Paiement">
      <ResponsiveContainer width="100%" height={500}>
        <BarChart
          barGap={4}
          width={500}
          height={300}
          data={monthlyFinanceDataByEcoleId}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barSize={40}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" angle={24} fontSize={14} tickMargin={16} />
          <YAxis />
          <Tooltip
            cursor={{
              opacity: 0.4,
            }}
            content={value => <CustomTooltip {...value} />}
          />
          <Legend wrapperStyle={{ paddingTop: 14 }} />
          <Bar dataKey="monthlyEncaissements" name={`Encaissement`} fill="#1e9b52" background={{ fill: 'transparent' }} />
          <Bar dataKey="monthlyPaiementsSalaires" name={`Paiement`} fill="#a94d56" background={{ fill: 'transparent' }} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default BarChartCard;
const CustomTooltip = ({ payload, label, active }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: 'whitesmoke', border: 'none', padding: '5px' }}>
        <p style={{ color: '#000', margin: 0 }}>{`${label}`}</p>
        <p style={{ color: '#1e9b52', margin: 0 }}>{`Encaissement: ${payload[0].value} FCFA`}</p>
        <p style={{ color: '#bf616a', margin: 0 }}>{`Paiement: ${payload[1].value} FCFA`}</p>
      </div>
    );
  }
  return null;
};
